import Vue from 'vue/dist/vue.esm.js';
import gsap from 'gsap';

let parent = document.getElementById('#expectWrapper');
// DUMMY DATA
let data = [
  {
    headline: 'A Relaxed No Obligation Consultation',
    description: 'Every procedure starts with a private no commitment conversation with either Richard or Kim. We want to know your targets and how we can help you reach them.',
    time: '1 HOUR',
  },
  {
    headline: 'Book and Prepare for your Surgery',
    description: 'When you’re ready we book in your procedure. At Re. we believe the preparation for the surgery, and the care you receive after the surgery is as important as the procedure itself. It’s why we developed a special whole-of-journey program called Re.Care.',
    time: '1-2 WEEKS',
  },
  {
    headline: 'A Relaxed No Obligation Consultation',
    description: 'Every procedure starts with a private no commitment conversation with either Richard or Kim. We want to know your targets and how we can help you reach them.',
    time: '1 HOUR',
  },
  {
    headline: 'Book and Prepare for your Surgery',
    description: 'When you’re ready we book in your procedure. At Re. we believe the preparation for the surgery, and the care you receive after the surgery is as important as the procedure itself. It’s why we developed a special whole-of-journey program called Re.Care.',
    time: '1-2 WEEKS',
  },
]

Vue.component('what-to-expect', {
  data() {
    return {
      activeIndex: 0,
    }
  },
  props: {
    elements: {
      type: Array,
      required: true,
      default: ()=>{
        return data;
      }
    }
  },
  mounted(){
    this.setupIntersection();
  },
  methods: {
    setActiveIndex: function(index){
      this.activeIndex = index;
    },
    scrollToAndUpdateIndex: function(index){
      document.querySelector('.what-to-expect__content').scrollLeft =
        document.querySelector(`.what-to-expect__content [data-index="${index}"]`).offsetLeft - 60;
      this.setActiveIndex(index);
    },
    setupIntersection: function(){
      const allEls = document.querySelectorAll(".what-to-expect__el");
      const options = {
        root: document.querySelector('.what-to-expect__content'),
        rootMargin: '0px',
        threshold: 0.9
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.setActiveIndex(entry.target.dataset.index);
          }
        });
      }, options);

      allEls.forEach((el)=>{
        observer.observe(el);
      })
    }
  }
});

new Vue({}).$mount('#expectWrapper');
